import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

import { PublicRoutes } from "@/routes/PublicRoutes";
import { OnboardingRoutes } from "@/routes/OnboardingRoutes";
import { CustomerRoutes } from "@/routes/CustomerRoutes";
import { AdminRoutes } from "@/routes/AdminRoutes";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          {PublicRoutes}
          {OnboardingRoutes}
          {CustomerRoutes}
          {AdminRoutes}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
